import React from 'react'
import { Container, Row,Colseis,Coltres, FooterMenu, Linkshare, Iconfooter } from './styles'
import { FaTwitter, FaFacebookF,FaYoutube,FaLinkedinIn,FaInstagram,FaEnvelope,FaPhone } from "react-icons/fa";




export const Footer = (props) => {

    return(
        <FooterMenu>
            <Container>
                <Row>
                    <Colseis>
                        <img src={process.env.PUBLIC_URL + '/images/La-Neurona-logo.png'} alt="La Neurona" />
                        <div className="footercontacto">
                            Primera <b>plataforma</b> de contenidos para <b>directivos</b> y <b>profesionales.</b><br/>
                            Creamos y difundimos contenidos en cualquier formato y canal.
                        </div>
                    </Colseis>
                    <Coltres>
                        <h3>CONTACTO</h3>
                        <div className="footercontacto">
                            <div><FaEnvelope size="12" value={{  className: "iconHeader" }} /> <a href="mailto:info@laneurona.com">info@laneurona.com</a></div>
                            <div><FaPhone size="12" value={{  className: "iconHeader" }} /> <a href="tel:+34917638711">+34 91 763 87 11</a></div>
                        </div>
                    </Coltres>
                    <Coltres>
                        <h3>SÍGUENOS  EN</h3>
                        <div  className="inline">
                            <Linkshare href="https://www.youtube.com/channel/UCnsswyWWJGz8kjRlnTqlcig" target="_blank" rel="noopener noreferrer" ><Iconfooter><FaYoutube size="16" value={{  className: "iconHeader" }} /></Iconfooter></Linkshare>
                            <Linkshare href="https://twitter.com/LaNeurona_com" target="_blank" rel="noopener noreferrer" ><Iconfooter><FaTwitter size="16" value={{  className: "iconHeader" }} /></Iconfooter></Linkshare>
                            <Linkshare href="https://www.instagram.com/laneurona_com/" target="_blank" rel="noopener noreferrer" ><Iconfooter><FaInstagram size="16" value={{  className: "iconHeader" }} /></Iconfooter></Linkshare>
                            <Linkshare href="https://www.facebook.com/LaNeuronacom" target="_blank" rel="noopener noreferrer" ><Iconfooter><FaFacebookF size="16" value={{  className: "iconHeader" }} /></Iconfooter></Linkshare>
                            <Linkshare href="https://www.linkedin.com/company/laneuronacom/%20" target="_blank" rel="noopener noreferrer" ><Iconfooter><FaLinkedinIn size="16" value={{  className: "iconHeader" }} /></Iconfooter></Linkshare>
                        </div>
                    </Coltres>
                </Row>
                <Row>
                    <div className="footerlinks">
                        <a href="https://interbanservices.com/formularios/newsletter_neurona/a000X000013DEnB" target="_blank" rel="noopener noreferrer">Suscríbete a la Newsletter</a>  |  
                        <a href="https://laneurona.com/quienes-somos/" target="_blank" rel="noopener noreferrer">Quiénes somos</a> |
                        <a href="https://laneurona.com/contacto/" target="_blank" rel="noopener noreferrer">Contacto</a> |
                        <a href="https://patrociniob2b.laneurona.com/" target="_blank" rel="noopener noreferrer">Patrocinio</a> |
                        <a href="https://laneurona.com/terminos-y-condiciones/" target="_blank" rel="noopener noreferrer">Condiciones y privacidad</a> |
                        <span>Interban Network S.L</span>
                    </div>
                </Row>
            </Container>
        </FooterMenu> 
    )
}